import { ISelectOption } from '../../ui-toolkit';

export interface ISigningAppointmentStatusResponse {
  id: string;
  label: string;
  shortLabel: string;
  description?: string;
  type: eSigningAppointmentStatusTypes;
}

export enum eSigningAppointmentStatusTypes {
  Pending = 'pending',
  OnTrack = 'on-track',
  OffTrack = 'off-track',
  Cancelled = 'cancelled',
  Draft = 'draft',
  SelectionPending = 'selection-pending',
  SignerConfirmed = 'signer-confirmed',
}

export enum eSigningAppointmentConfirmationStatus {
  Requested = 'requested',
  Scheduled = 'scheduled',
}

export enum eSigningAppointmentStatusOptions {
  Requested = 'requested',
  Scheduled = 'scheduled',
  DocumentsShared = 'documents-shared',
  Complete = 'complete',
  Reschedule = 'reschedule-required',
  Canceled = 'cancelled',
}

export const getSigningStatusLabel = (id: string, statuses: ISigningAppointmentStatusResponse[]): string => {
  return statuses.find((s) => s.id === id)?.label || '';
};

export const getStatus = (
  id: string | undefined,
  statuses: ISigningAppointmentStatusResponse[]
): ISigningAppointmentStatusResponse | undefined => {
  const res = statuses.find((s) => s.id === id);
  if (!res) {
    console.warn('Invalid signing appointment status id ' + id);
  }
  return res;
};

export const BadgeColorsBySigningAppointmentStatusTypes: Record<eSigningAppointmentStatusTypes, string> = {
  [eSigningAppointmentStatusTypes.Pending]: 'bg-lightBlue-100 text-lightBlue-800',
  [eSigningAppointmentStatusTypes.OnTrack]: 'bg-green-100 text-green-800',
  [eSigningAppointmentStatusTypes.OffTrack]: 'bg-yellow-100 text-yellow-800',
  [eSigningAppointmentStatusTypes.Cancelled]: 'bg-red-100 text-red-800',
  [eSigningAppointmentStatusTypes.Draft]: 'bg-yellow-100 text-yellow-600',
  [eSigningAppointmentStatusTypes.SelectionPending]: 'bg-extra-aqua-100 text-extra-aqua-600',
  [eSigningAppointmentStatusTypes.SignerConfirmed]: 'bg-green-100 text-green-800',
};

export const convertISigningAppointmentStatusResponseToISelectOption = (
  status: ISigningAppointmentStatusResponse
): ISelectOption => {
  return {
    label: status.label,
    value: status.id,
  };
};

export const getStatusOptions = (signingStatuses: ISigningAppointmentStatusResponse[]): ISelectOption[] =>
  signingStatuses.map(convertISigningAppointmentStatusResponseToISelectOption);

export const getStatusDescriptions = (signingStatuses: ISigningAppointmentStatusResponse[]): Record<string, string> =>
  signingStatuses.reduce((descriptionsById: any, status) => {
    descriptionsById[status.id] = status.description;
    return descriptionsById;
  }, {});

export const filterDssAttorneyStatusOptions = (
  signingStatuses: ISelectOption[],
  isDraft?: boolean,
  isConfirmed?: boolean,
  status?: eSigningAppointmentConfirmationStatus
) => {
  if (isDraft || !isConfirmed) {
    return signingStatuses.filter((option) => option.value === eSigningAppointmentStatusOptions.Canceled);
  }

  if (status === eSigningAppointmentConfirmationStatus.Requested) {
    return signingStatuses.filter(
      (option) =>
        option.value === eSigningAppointmentStatusOptions.Canceled ||
        option.value === eSigningAppointmentStatusOptions.Scheduled
    );
  }

  return signingStatuses.filter(
    (option) =>
      option.value === eSigningAppointmentStatusOptions.DocumentsShared ||
      option.value === eSigningAppointmentStatusOptions.Complete ||
      option.value === eSigningAppointmentStatusOptions.Reschedule ||
      option.value === eSigningAppointmentStatusOptions.Canceled
  );
};
